import { useServerSideFilters } from "@/hooks/useQueryFilters";
import { InvoiceSmbReviewStatus } from "@/lib/constants/invoiceStatus";
import { useMemo } from "react";
import { useInvoiceLiveCountsSubscription } from "../live-counts";

export const useTransfersLiveCountsSubscription = () => {
  const serverSideQuery = useServerSideFilters({
    query: bankTranfersToPayFilters,
  });

  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: serverSideQuery,
  });

  return { liveCounts, loading };
};

export const bankTranfersToPayFilters = {
  smbReviewStatus: [
    InvoiceSmbReviewStatus.REVIEWED,
    InvoiceSmbReviewStatus.REVIEWED_ZERO_TOUCH,
  ],
  isPaid: false,
};
